const truncateOwner = (string) => {
  let truncated1 = string.slice(0, 5);
  let truncated2 = string.slice(string.length - 4);
  return truncated1 + "..." + truncated2;
};

export default truncateOwner;
